import { render, staticRenderFns } from "./modalUpdatePass.vue?vue&type=template&id=21028547"
import script from "./modalUpdatePass.vue?vue&type=script&lang=js"
export * from "./modalUpdatePass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports